
const lang = {
  app: {},

  removeFormat: {title: 'Убрать форматирование'},

  bold: {title: 'Жирный'},
  italic: {title: 'Курсив'},
  underline: {title: 'Подчеркнутый'},
  strikeThrough: {title: 'Перечеркнутый'},

  superscript: {title: 'Верхний индекс'},
  subscript: {title: 'Нижний индекс'},
  indent: {title: 'Отступ'},
  outdent: {title: 'Выступ'},

  justifyLeft: {title: 'По левому краю'},
  justifyCenter: {title: 'По центру'},
  justifyRight: {title: 'По правому краю'},
  justifyFull: {title: 'На всю ширину'},

  insertOrderedList: {title: 'Вставить нумерованный список'},
  insertUnorderedList: {title: 'Вставить ненумерованный список'},

  foreColor: {
    title: 'Цвет шрифта',
    ok: 'ok',
    colorCode: 'Цветовой режим',
    invalidColorCodeMsg: 'Пожалуйста введите корректный цветовой код'
  },
  backColor: {
    title: 'Цвет фона',
    ok: 'ok',
    colorCode: 'Цветовой режим',
    invalidColorCodeMsg: 'Пожалуйста введите корректный цветовой код'
  },

  fontName: {},
  fontSize: {},
  code: {},
  element: {},

  design: {
    ieMsg: 'Вы должны выбрать текст, чтобы использовать эту функцию в браузере IE'
  },
  link: {
    title: 'Добавить ссылку',
    ok: 'OK'
  },
  unLink: {
    title: 'Убрать ссылку'
  },
  markdown: {
    title: 'markdown'
  },
  picture: {
    title: 'Вставить изображение',
    ok: 'OK',
    cancel: 'Отмена',
    invalidFile: 'Выбранный файл не является изображением'
  },
  sourceCode: {
    title: 'Исходный код'
  },
  fullscreen: {
    title: 'полный экран'
  },
  table: {title: 'Таблица'},
  undo: {title: 'Назадо'},
  redo: {title: 'Вперед'}
}
export default lang



// WEBPACK FOOTER //
// ./src/components/vueditor/lang.ru.js